import { getYandexMetrikaCounter, getYandexMetrikaCounterId } from 'utils/analytics/yandexMetrika'
import { sendEvent } from 'utils/analytics/sendEvent'
import { onboardingLog } from './store/logger'

/**
 * Send reachGoal events configured on a learning config button.
 * @param {object} button — Button from learningConfigs
 * @param {{ trackId?: string, cardId?: string, pageId?: string }} [context]
 */
export const trackOnboardingButtonAnalytics = (button, context = {}) => {
  const goal =
    button?.analyticsGoal ??
    (button?.action === 'confirm-interrupt' ? 'onboarding_close_click' : null)

  if (!goal) {
    onboardingLog('analytics:skip', {
      reason: 'no analyticsGoal',
      action: button?.action,
      label: button?.label,
      ...context,
    })
    return
  }

  sendOnboardingEvent(goal, {
    trackId: context.trackId,
    cardId: context.cardId,
    pageId: context.pageId,
    ...button.analyticsParams,
  })
}

/**
 * Send onboarding event to analytics channels and write an onboarding debug log.
 * @param {string} eventName - event goal name
 * @param {object} [params] - optional params for the event
 */
export const sendOnboardingEvent = (eventName, params) => {
  const counterId = getYandexMetrikaCounterId()
  const hasYm = Boolean(counterId && typeof window?.ym === 'function')
  const hasDataLayer = Boolean(global.dataLayer)

  sendEvent(eventName, params)

  onboardingLog('analytics:send', {
    goal: eventName,
    params,
    counterId,
    channels: {
      yaCounter: Boolean(getYandexMetrikaCounter()),
      ym: hasYm,
      dataLayer: hasDataLayer,
    },
  })
}
